import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["title", "aria-label"]


//@ts-ignore
import {translate} from '@elements/translations';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormLabel',
  props: {
    className: {
        type: String,
        default: 'form-label'
    },
    label: String,
    id: String,
    required: Boolean,
    tooltip: String
},
  setup(__props) {

const props = __props;

//@ts-ignore


return (_ctx: any,_cache: any) => {
  return (__props.label)
    ? (_openBlock(), _createElementBlock("label", {
        key: 0,
        class: _normalizeClass(__props.className),
        for: __props.id
      }, [
        _createTextVNode(_toDisplayString(__props.label) + " ", 1),
        _renderSlot(_ctx.$slots, "default"),
        (__props.required)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              title: _unref(translate)('general.required'),
              "aria-label": _unref(translate)('general.required')
            }, "*", 8, _hoisted_2))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})